import { FC, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { linkMainMenu } from 'src/utils/menuSet';
import { menuSet } from 'src/static/admin_menu';
import { contentModalViewStore } from 'src/store/modal';
import NatinalPensionGrid from 'src/components/molecules/table/NatinalPension';
import InsurfreeGrid from 'src/components/molecules/table/Insurfree';
import MedicalExpenses from 'src/components/molecules/table/MedicalExpenses';
import Education from 'src/components/molecules/table/Education';
import Donation from 'src/components/molecules/table/Donation';
import PensionSavings from 'src/components/molecules/table/PensionSavings';
import CreditCardDiv from 'src/components/organisms/template/StepC/template/TaxModal/CreditCard';
import HousingDiv from 'src/components/organisms/template/StepC/template/TaxModal/HousingDiv';
import EtcInputDiv from 'src/components/organisms/template/StepC/template/TaxModal/EtcInputDiv';
import { errorModalViewStore, loadingModalViewStore } from 'src/store/modal';
import { settlementDataStore } from 'src/store/settlementInfo';
import { QueryClient, useQueryClient } from '@tanstack/react-query';
import { settlementInfoDataFn } from 'src/fetch/stepC/settlement';
import { familyDataStore } from 'src/store/familyInfo';
import { getMemberInfo } from 'src/utils/common';
import { addComma } from 'src/utils/common';
import './style.scss';

interface SubMenuItem {
  id: number;
  title: string;
  icon: string;
  status: 'complete' | 'in_progress' | 'wait';
  statusLabel: string;
  modalKey: string;
}

interface MenuItem {
  pageNum: number;
  title: string;
  icon: string;
  status: 'complete' | 'in_progress' | 'wait';
  statusLabel: string;
  desc?: string;
  subMenus: SubMenuItem[];
}

const MENU_DATA: MenuItem[] = menuSet().map((m: any) => ({
  pageNum: m.num,
  title: m.title,
  icon: m.icon,
  status: m.status,
  statusLabel: m.statusLabel,
  desc: m.desc,
  subMenus: m.subMenus ?? [],
}));

interface Props {}

const MainLeft: FC<Props> = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const queryClient = useQueryClient();
  const userInfoData: any = getMemberInfo();

  const setContentModalState = contentModalViewStore((s: any) => s.set);
  const member: any = getMemberInfo() || { name: '홍길동', co_id: 'A4321', acct_year: '2026' };
  const errorModalState = errorModalViewStore((state: any) => state.set);

  const initPageNum: number = state?.pageNum || 0;
  // const [selectedPageNum, setSelectedPageNum] = useState<number>(initPageNum);
  const selectedIndex = MENU_DATA.findIndex(m => m.pageNum === initPageNum);

  const settlementDataInitState = settlementDataStore((state: any) => state.bind);
  const settlementDataParam = settlementDataStore((state: any) => state.param);
  const settlementData = settlementDataStore((state: any) => state.result).data || {};

  let refundStatus = 0;
  let refundStatusText = '환급';
  refundStatus = settlementData.total?.totRefundPaid || 0; // 환급/납부
  const determinedPaid = settlementData.total?.totDeterminedPaid || 0; // 결정세액
  const prePaid = settlementData.total?.totPrePaid || 0; // 기납세액
  if (determinedPaid > prePaid) {
    refundStatus = refundStatus * -1;
    refundStatusText = '추가납부';
  }

  // 총 소득
  const totalSalary = settlementData?.result?.gross_salary || 0;
  MENU_DATA.forEach((item: any) => {
    if (item.pageNum === 1)
      item.desc = (
        <div className="_left_grossary_desc">
          <span>총소득</span> {addComma(totalSalary)} <span>원</span>
        </div>
      );
  });

  const familyInfoData = familyDataStore((state: any) => state.result).data;

  const familyInfo: any = MENU_DATA.find((item: any) => item.pageNum === 0);
  familyInfo.desc = (
    <div className="_left_family_desc">
      <div className="_name">{member.name}</div>
      {/* <div className="_sub">
        {' '}
        외 <span>{familyInfoData.length}</span>명 등록
      </div> */}
    </div>
  );

  useEffect(() => {
    const param: any = userInfoData;
    settlementInfoDataFn(errorModalState, param, settlementDataInitState, queryClient);
  }, [settlementDataParam]);

  const getItemClass = (index: number) => {
    if (index < selectedIndex) return '_asis';
    if (index === selectedIndex) return '_selected';
    return '_next';
  };

  const getZIndex = (index: number) => index + 1;

  const MODAL_MAP: Record<string, { title: string; content: React.ReactNode }> = {
    insurance_health_pension: {
      title: '국민연금/건강보험료(추가납부) 상세',
      content: <NatinalPensionGrid type="list" />,
    },
    insurance: { title: '보험료 상세', content: <InsurfreeGrid type="list" /> },
    medical: { title: '의료비 상세', content: <MedicalExpenses type="list" /> },
    education: { title: '교육비 상세', content: <Education type="list" /> },
    donation: { title: '기부금 상세', content: <Donation type="list" /> },
    housing: { title: '주택자금 상세', content: <HousingDiv type="list" /> },
    pension_savings: { title: '연금저축등 상세', content: <PensionSavings type="list" /> },
    others: { title: '기타입력 상세', content: <EtcInputDiv type="list" /> },
    credit_card: { title: '신용카드 외 상세', content: <CreditCardDiv type="list" /> },
  };

  const openSubModal = (e: React.MouseEvent, sub: SubMenuItem) => {
    e.stopPropagation();
    const modal = MODAL_MAP[sub.modalKey];
    if (!modal) return;
    setContentModalState({
      active: '_active',
      title: modal.title,
      content: modal.content,
      styleDef: { width: '1024px' },
    });
  };

  return (
    <div className="_menu_left_set">
      <div className="_menu_div">
        {MENU_DATA.map((item, index) => {
          const typeClass = getItemClass(index);
          const isSelected = typeClass === '_selected';

          return (
            <div
              key={item.pageNum}
              className={['_item', typeClass].join(' ')}
              style={{ zIndex: getZIndex(index) }}
              onClick={() => {
                if (isSelected) return;
                // setSelectedPageNum(item.pageNum);
                linkMainMenu({ num: item.pageNum, navigate });
              }}
            >
              <div className="_title_div">
                <div className="_title_set">
                  <div className="_icon">
                    <i className={item.icon} />
                  </div>
                  <div className="_title">{item.title}</div>
                  <div className="_status">
                    <div className={['_label', `_${item.status}`].join(' ')}>
                      {item.statusLabel}
                    </div>
                  </div>
                </div>
                {/* {item.desc && <div className="_line_div" />} */}
              </div>

              {item.desc && (
                <div className="_sub_div">
                  <div className="_desc">{item.desc}</div>
                </div>
              )}

              {isSelected && item.subMenus.length > 0 && (
                <div className="_sub_menu_div">
                  {item.subMenus.map(sub => (
                    <div key={sub.id} className="_sub_menu" onClick={e => openSubModal(e, sub)}>
                      <div className="_icon">
                        <i className={sub.icon} />
                      </div>
                      <div className="_title">{sub.title}</div>
                      <div className="_status">
                        <div className={['_label', `_${sub.status}`].join(' ')}>
                          {sub.statusLabel}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}

              {item.pageNum === 4 && (
                <div className="_result_div">
                  <div className={refundStatus < 0 ? '_main _minus' : '_main _add'}>
                    {/* <div className="_main _add"> */}
                    <div className="_icon">
                      <i className="ri-exchange-2-line"></i>
                    </div>
                    <div className="_label">{refundStatusText}</div>
                    <div className="_cont">
                      {/* <span className="_seper">{refundStatus < 0 ? '+' : '-'}</span> */}
                      {addComma(Math.abs(refundStatus))}
                      <em>원</em>
                    </div>
                  </div>
                  <div className="_sub">
                    <div className="_sub_box">
                      <div className="_item">
                        <div className="_label">결정세액</div>
                        <div className="_cont">
                          {addComma(determinedPaid)}
                          <em>원</em>
                        </div>
                      </div>
                      <div className="_item">
                        <div className="_label">기납세액</div>
                        <div className="_cont">
                          {addComma(prePaid)}
                          <em>원</em>
                        </div>
                      </div>
                      <div className="_item _tot">
                        <div className="_label">차감징수세액</div>
                        <div className="_cont">
                          {addComma(Math.abs(refundStatus))}
                          <em>원</em>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MainLeft;
